module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "add-user fill-height",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "div-center-horizontally"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-container', {
    staticClass: "medium-div"
  }, [_c('v-layout', {
    staticClass: "header-row",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "div-center-vertically"
  }, [(_vm.userRegisterStep == 1) ? _c('p', {
    staticClass: "org-name"
  }, [_vm._v(_vm._s(_vm.organization))]) : (_vm.userRegisterStep == 2) ? _c('p', {
    staticClass: "org-name"
  }, [_c('a', {
    staticClass: "org-name-clickable",
    on: {
      "click": function($event) {
        _vm.userRegisterStep = 1
      }
    }
  }, [_vm._v(_vm._s(_vm.userData.name) + " " + _vm._s(_vm.userData.lastName))]), _vm._v(" / " + _vm._s(_vm.$t('AddUser.devices')))]) : (_vm.userRegisterStep == 3) ? _c('p', {
    staticClass: "org-name"
  }, [_c('a', {
    staticClass: "org-name-clickable",
    on: {
      "click": function($event) {
        _vm.userRegisterStep = 1
      }
    }
  }, [_vm._v(_vm._s(_vm.userData.name) + " " + _vm._s(_vm.userData.lastName))]), _vm._v(" / "), _c('a', {
    staticClass: "org-name-clickable",
    on: {
      "click": function($event) {
        _vm.userRegisterStep = 2
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('AddUser.devices')))]), _vm._v(" / " + _vm._s(_vm.$t('AddUser.permissions')))]) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    staticClass: "card-actions div-center-vertically div-right-horizontally"
  }, [_c('p', {
    staticClass: "user-register-text"
  }, [_vm._v(_vm._s(_vm.$t('AddUser.userRegister')))]), _vm._v(" "), _c('v-btn', {
    staticClass: "close-icon",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeCard
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#000000"
    }
  }, [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "divider-row",
    attrs: {
      "row": ""
    }
  }, [_c('v-divider', {
    staticClass: "divider"
  })], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "user-content-row",
    attrs: {
      "row": ""
    }
  }, [(_vm.userRegisterStep == 1) ? _c('NewUser', {
    attrs: {
      "userRegisterStep": _vm.userRegisterStep,
      "userData": _vm.userData,
      "fromNewCampaign": _vm.fromNewCampaign,
      "originCampaignId": _vm.originCampaignId,
      "newCampaignStep": _vm.newCampaignStep,
      "fromNewField": _vm.fromNewField,
      "fromNewFieldData": _vm.fromNewFieldData
    },
    on: {
      "update:userRegisterStep": function($event) {
        _vm.userRegisterStep = $event
      },
      "update:user-register-step": function($event) {
        _vm.userRegisterStep = $event
      },
      "update:userData": function($event) {
        _vm.userData = $event
      },
      "update:user-data": function($event) {
        _vm.userData = $event
      }
    }
  }) : (_vm.userRegisterStep == 2) ? _c('AssignDevices', {
    attrs: {
      "userRegisterStep": _vm.userRegisterStep,
      "userData": _vm.userData
    },
    on: {
      "update:userRegisterStep": function($event) {
        _vm.userRegisterStep = $event
      },
      "update:user-register-step": function($event) {
        _vm.userRegisterStep = $event
      },
      "update:userData": function($event) {
        _vm.userData = $event
      },
      "update:user-data": function($event) {
        _vm.userData = $event
      }
    }
  }) : (_vm.userRegisterStep == 3) ? _c('PermissionsByDevice', {
    attrs: {
      "userData": _vm.userData,
      "fromNewUser": true
    },
    on: {
      "update:userData": function($event) {
        _vm.userData = $event
      },
      "update:user-data": function($event) {
        _vm.userData = $event
      }
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c9293ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Additions/AddUser.vue
// module id = 1697
// module chunks = 0